function a(r){const{m:t,mx:m,my:o,mt:p,mr:n,mb:s,ml:e,...i}=r;return{m:t,mx:m,my:o,mt:p,mr:n,mb:s,ml:e,rest:i}}export{a as extractMarginProps};
//# sourceMappingURL=extract-margin-props.js.map
